const validate = (values) => {
  const errors = {};

  if (!values.therapyName || values.therapyName.trim() === '') {
    errors.therapyName = 'Please enter therapy name';
  }
  // if (!values.description) {
  //   errors.description = 'Please enter description';
  // } 
  return errors;
};
export default validate;



// WEBPACK FOOTER //
// ./src/modules/Masters/components/masterTherapy/validate.js